import React, { forwardRef, useImperativeHandle } from "react"
import {Grid} from "semantic-ui-react"
import DropDown from "../../../components/commonComponents/formComponents/dropDown";
import { relIndVal, dispStatusVal, accStatusVal } from "./mockConstants";

const Box44Mock = forwardRef((props, ref) => {
    
    const [releaseIndicator, setRelInd] = React.useState("");
    const [accountingStatus, setAccStatus] = React.useState("");
    const [dispatchStatus, setDispStatus] = React.useState("");

    useImperativeHandle(ref, () => ({
        getBox44Data: () =>  ({
                releaseIndicator,
                accountingStatus,
                dispatchStatus
        })
    }));

    return ( 
        <>
            <Grid.Row className="entry-number-row">
                <Grid.Column computer={5}>
                    <DropDown 
                        style={{"borderColor": "#1765AE"}}
                        label="Release Indicator"
                        type="text"
                        id='status'
                        className="status-dropdown field-bg dropdown100"
                        data={relIndVal}
                        value={releaseIndicator === -1 ? "SELECT" : releaseIndicator}
                        onChange={(value) => setRelInd(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <DropDown 
                        style={{"borderColor": "#1765AE"}}
                        type="text"
                        label="Dispatch Status"
                        id='status'
                        className="status-dropdown field-bg dropdown100"
                        data={dispStatusVal}
                        value={dispatchStatus === -1 ? "SELECT" : dispatchStatus}
                        onChange={(value) => setDispStatus(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <DropDown 
                        style={{"borderColor": "#1765AE"}}
                        type="text"
                        label="Accounting Status"
                        id='status'
                        className="status-dropdown field-bg dropdown100"
                        data={accStatusVal}
                        value={accountingStatus === -1 ? "SELECT" : accountingStatus}
                        onChange={(value) => setAccStatus(value)}
                    />
                </Grid.Column>
            </Grid.Row>
        </>
     );
})
 
export default Box44Mock;